import { assign, createMachine } from 'xstate';

import { ShowingRequestPropertyQuery_buyer_getPropertyByAddressId_property as Property } from 'buying/graphql/queries/__generated__/ShowingRequestPropertyQuery';

/**
 * Validates a phone number. Accepts 10 digit numbers and 11 digit numbers starting with 1.
 */
export const phoneValidator = (txt: string) => {
  const phoneNumber = txt.replace(/\D/g, '');
  return 10 === phoneNumber.length || !!phoneNumber.match(/^1\d{10}$/);
};

export interface ShowingRequestCreationContext {
  addressId?: string;
  property?: Property;
}

export const ShowingRequestCreationStateMachine = createMachine<ShowingRequestCreationContext>(
  {
    context: {
      addressId: undefined,
    },
    schema: {
      events: {} as
        | { type: 'setAddressId'; value: string }
        | { type: 'setProperty'; value: Property },
    },
    id: 'showing-request-creation',
    initial: 'IDLE',
    states: {
      IDLE: {
        on: {
          FORWARD: {
            target: 'PROPERTY_CONFIRM',
            cond: (context) => context.addressId !== undefined,
          },
          setAddressId: {
            actions: 'setAddressId',
          },
          setProperty: {
            actions: 'setProperty',
          },
        },
      },
      PROPERTY_CONFIRM: {
        on: {
          FORWARD: [
            {
              target: 'DOWNLOAD_APP',
              cond: (context) => !!context.property?.opendoorOwned,
            },
            {
              target: 'REDIRECT',
              cond: (context) => !context.property?.opendoorOwned,
            },
          ],
        },
      },
      DOWNLOAD_APP: {
        on: {
          FORWARD: {
            target: 'APP_REDIRECT',
          },
        },
      },
      REDIRECT: {
        type: 'final',
      },
      APP_REDIRECT: {
        type: 'final',
      },
    },
  },
  {
    actions: {
      setAddressId: assign({
        addressId: (_, event) => event.value,
      }),
      setProperty: assign({
        property: (_, event) => event.value,
      }),
    },
  },
);
